export type AcceptedFileType =
  | 'PDF'
  | 'DOCX'
  | 'XLSX'
  | 'PPTX'
  | 'IMAGE'
  | 'VIDEO'
  | 'AUDIO';

const ACCEPT_ATTRIBUTE = {
  PDF: ['.pdf', 'application/pdf'],
  DOCX: [
    '.doc',
    '.docx',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ],
  XLSX: [
    '.xls',
    '.xlsx',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ],
  PPTX: [
    '.ppt',
    '.pptx',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  ],
  IMAGE: ['.jpg', '.jpeg', '.png', 'image/jpeg', 'image/png'],
  VIDEO: [
    '.mp4',
    '.mov',
    '.avi',
    'video/mp4',
    'video/quicktime',
    'video/x-msvideo',
  ],
  AUDIO: ['.mp3', '.wav', 'audio/mpeg', 'audio/wav'],
};

export const ACCEPTED_EXTENSIONS = {
  PDF: ['.pdf'],
  DOCX: ['.doc', '.docx'],
  XLSX: ['.xls', '.xlsx'],
  PPTX: ['.ppt', '.pptx'],
  IMAGE: ['.jpg', '.jpeg', '.png'],
  VIDEO: ['.mp4', '.mov', '.avi'],
  AUDIO: ['.mp3', '.wav'],
};

export const ACCEPTED_MIME_TYPES = {
  PDF: ['application/pdf'],
  DOCX: [
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ],
  XLSX: [
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ],
  PPTX: [
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  ],
  IMAGE: ['image/jpeg', 'image/png'],
  VIDEO: ['video/mp4', 'video/quicktime', 'video/x-msvideo'],
  AUDIO: ['audio/mpeg', 'audio/wav'],
};

const acceptedFileAttributes = (
  fileType: AcceptedFileType | AcceptedFileType[]
) => {
  return (typeof fileType === 'string' ? [fileType] : fileType)
    .reduce((previousValue: string[], currentValue) => {
      return [...previousValue, ...ACCEPT_ATTRIBUTE[currentValue]];
    }, [])
    .join(',');
};

export default acceptedFileAttributes;
